// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './roles-api';

export const useListRoles: typeof hookExports.useListRoles = hookExports.useListRoles;
export const useLazyListRoles: typeof hookExports.useLazyListRoles = hookExports.useLazyListRoles;
export const useGetRole: typeof hookExports.useGetRole = hookExports.useGetRole;
export const useLazyGetRole: typeof hookExports.useLazyGetRole = hookExports.useLazyGetRole;
export const useCreateRole: typeof hookExports.useCreateRole = hookExports.useCreateRole;
export const useUpdateRole: typeof hookExports.useUpdateRole = hookExports.useUpdateRole;
export const useDeleteRole: typeof hookExports.useDeleteRole = hookExports.useDeleteRole;
